<div class="admin-claims row is-modal col-md-12">
    <p class="body text-dark-gray">
        Enabling the permissions below will grant administrative functionality to the areas
        selected.
    </p>
    <div class="user-permissions-control list-unstyled">
        <div class="section-header" style="margin-top: 2rem;">
            <ng-template #permissionControlLabelTemplate>
                <p class="user-permissions-control-label text-bold">
                    {{ adminSystemClaimManagementUiControl.label }}
                </p>
                <p>{{ adminSystemClaimManagementUiControl.description }}</p>
            </ng-template>

            <lsq-switch
                [(ngModel)]="adminSystemClaimManagementUiControl.isOn"
                (ngModelChange)="emitChanges(adminSystemClaimManagementUiControl.claims)"
                [disabled]="readOnly"
                [name]="'permissionControl' + adminSystemClaimManagementUiControl.claims[0]"
                [labelOrientation]="orientation.Right"
                [labelTemplateRef]="permissionControlLabelTemplate"
                (claimsChange)="emitChanges($event)"
            >
            </lsq-switch>
        </div>
        <div class="section-header" style="margin-top: 2rem;">
            <ng-template #permissionAdminManagement>
                <p class="user-permissions-control-label text-bold">
                    {{ adminSystemManagementUiControl.label }}
                </p>
            </ng-template>

            <lsq-switch
                [(ngModel)]="adminSystemManagementUiControl.isOn"
                (ngModelChange)="emitChanges(adminSystemManagementUiControl.claims)"
                [disabled]="readOnly"
                [name]="'permissionControl' + adminSystemManagementUiControl.claims[0]"
                [labelOrientation]="orientation.Right"
                [labelTemplateRef]="permissionAdminManagement"
                (claimsChange)="emitChanges($event)"
            >
            </lsq-switch>
        </div>
        <info-box
            *ngIf="!adminSystemManagementUiControl.isOn"
            [level]="'warning'"
            [icon]="icons.FaExclamationCircle"
            [style.marginBottom]="'2rem'"
            i18n
        >
            <p class="p text-bold">All permissions below for this user are currently disabled.</p>
        </info-box>
        <div
            *ngFor="let permissionControl of adminClaimManagementUiControls"
            class="user-permissions-control lsq-claim-row"
            [ngClass]="{
                'user-permissions-control-read-only': readOnly
            }"
        >
            <lsq-claim-row
                [viewClaimId]="permissionControl.viewClaims"
                [viewClaimModel]="permissionControl.viewIsOn"
                [editClaimId]="permissionControl.editClaims"
                [editClaimModel]="permissionControl.editIsOn"
                [claimName]="permissionControl.label"
                [claimDescription]="permissionControl.description"
                [disabled]="!adminSystemManagementUiControl.isOn || readOnly"
                (claimsChange)="emitChangesRowClaim($event, permissionControl)"
            >
            </lsq-claim-row>
        </div>
    </div>
</div>
